// extracted by mini-css-extract-plugin
module.exports = {"root":"ProgressBar_root__1-QNw","step":"ProgressBar_step__2y1n8","active":"ProgressBar_active__2r8AY","wiz":"ProgressBar_wiz__dvF_i","lastActive":"ProgressBar_lastActive__3qXwh"};